import { restRequest } from "vrcore-dashboard/dist/utilities";

export const SET_RESPONSE_MATRIX = restRequest("HSQE.SET_RESPONSE_MATRIX");
export const GET_RESPONSE_MATRIX = restRequest("HSQE.GET_RESPONSE_MATRIX");
export const SET_REPORT_DETAILS = restRequest("HSQE.SET_REPORT_DETAILS");
export const SET_NEW_GROUP = restRequest("HSQE.SET_NEW_GROUP");
export const GET_GROUPS = restRequest("HSQE.GET_GROUPS");
export const SET_ITEM = restRequest("HSQE.SET_ITEM");
export const GET_ITEMS = restRequest("HSQE.GET_ITEMS");
export const GET_TEMPLATES = restRequest("HSQE.GET_TEMPLATES")
export const REMOVE_TEMPLATE = restRequest("HSQE.REMOVE_TEMPLATE")
export const SELECTED_TEMPLATE = restRequest("HSQE.SELECTED_TEMPLATE")
